import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";

// 使用 lazy 加载页面组件
const SplashPage = lazy(() => import('../pages/splash'));
const PaymentPage = lazy(() => import('../pages/payment'));
const LoginPage = lazy(() => import('../pages/login'));
const HomePage = lazy(() => import('../pages/homePage'));
const DevicePage = lazy(() => import('../pages/device/device'));
const SecurityAudioPage = lazy(() => import('../pages/securityAudio/securityAudio'));
const Me = lazy(() => import('../pages/me/me'));
const ChangePassword = lazy(() => import('../pages/changePassword/changePassword'));
const About = lazy(() => import('../pages/about/about'));
const CustomerService = lazy(() => import('../pages/customerService/customerService'));

export const RouteContainer = () => {
  // 定义路由配置
  const routes = [
    {
      path: "/",
      element: <SplashPage />
    },
    {
      path: "/paymentPage",
      element: <PaymentPage />
    },
    {
      path: "/login",
      element: <LoginPage />
    },
    {
      path: "/home",
      element: <HomePage />
    },
    {
      path: "/device",
      element: <DevicePage />
    },
    {
      path: "/securityAudio",
      element: <SecurityAudioPage />
    },
    {
      path: "/me",
      element: <Me />
    }, 
    {
      path: "/changePassword",
      element: <ChangePassword />
    }, 
    {
      path: "/about",
      element: <About />
    },
    {
      path: "/customerService",
      element: <CustomerService />
    },  
  ];

  return (
    <Routes>
      {routes.map(item => (
        <Route
          key={item.path}
          path={item.path}
          element={
            <Suspense fallback={<div>Loading...</div>}>
              {item.element}
            </Suspense>
          }
        />
      ))}
    </Routes>
  );
};

export default RouteContainer;
